"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.Text = exports.LabelContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _styles = require("../../Tooltip/styles");
var _themes = _interopRequireDefault(require("../../themes"));
const LabelContainer = exports.LabelContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__LabelContainer",
  componentId: "sc-r8m1on-0"
})(["display:flex;flex-direction:row;align-items:center;cursor:default;width:100%;"]);
const Text = exports.Text = _styledComponents.default.span.withConfig({
  displayName: "styles__Text",
  componentId: "sc-r8m1on-1"
})(["font-family:", ";font-size:", ";font-weight:", ";letter-spacing:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;&::after{content:'';display:block;}"], ({
  theme
}) => theme.label.fontFamily, ({
  theme
}) => theme.label.fontSize, ({
  theme
}) => theme.label.fontWeight, ({
  theme
}) => theme.label.letterSpacing);
const Tooltip = exports.Tooltip = (0, _styledComponents.default)(_Tooltip.default).attrs(props => ({
  theme: props.theme || _themes.default
})).withConfig({
  displayName: "styles__Tooltip",
  componentId: "sc-r8m1on-2"
})(["", "{background:", ";color:", ";font-size:12px;font-weight:300;padding:5px;line-height:14px;box-shadow:0 1px 2px 0 ", ";&::after{position:absolute;content:'';display:inline-block;width:0;height:0;border-style:solid;border-color:", ";}}", ";"], _styles.TooltipInner, ({
  theme
}) => theme.colors.label.bg, ({
  theme
}) => theme.colors.label.text, ({
  theme
}) => theme.colors.label.shadow, ({
  theme
}) => theme.colors.label.bg, ({
  position
}) => {
  if (position === 'top') {
    return `
        ${_styles.TooltipInner} {
          &:after {
            left: 50%;
            right: auto;
            transform: translateX(-50%);

            bottom: 0;
            border-width: 5px 5px 0 5px;
            border-right-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        }
      `;
  }
  if (position === 'right') {
    return `
        ${_styles.TooltipInner} {
          &:after {
            bottom: auto;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            border-width: 5px 5px 5px 0;
            border-top-color: transparent;
            border-bottom-color: transparent;
            border-left-color: transparent;
          }
        }
      `;
  }
  if (position === 'left') {
    return `
        ${_styles.TooltipInner} {
          &:after {
            bottom: auto;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            border-width: 5px 0 5px 5px;
            border-top-color: transparent;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
        }
      `;
  }
  return `
      ${_styles.TooltipInner} {
        &:after {
          left: 50%;
          right: auto;
          transform: translateX(-50%);

          top: 0;
          border-width: 0 5px 5px 5px;
          border-top-color: transparent;
          border-right-color: transparent;
          border-left-color: transparent;
        }
      }
    `;
});